import { render, staticRenderFns } from "./edutalk-calendar.vue?vue&type=template&id=63e7e744"
import script from "./edutalk-calendar.vue?vue&type=script&lang=js"
export * from "./edutalk-calendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports